import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export interface GhlLocationIdResult {
  locationId: string | null;
  isLoading: boolean;
  error: string | null;
}

export function useGhlLocationId(organizationId: string): GhlLocationIdResult {
  const hasContext = Boolean(supabase) && Boolean(organizationId);
  const [locationId, setLocationId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(hasContext);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!supabase || !organizationId) {
      queueMicrotask(() => {
        setLocationId(null);
        setIsLoading(false);
      });
      return;
    }
    let cancelled = false;
    queueMicrotask(() => {
      setIsLoading(true);
      setError(null);
    });

    supabase
      .from("organizations")
      .select("ghl_location_id")
      .eq("id", organizationId)
      .single()
      .then(({ data, error: err }) => {
        if (cancelled) return;
        if (err) {
          setError(err.message || "Network error — refresh the page");
          setLocationId(null);
        } else if (!data?.ghl_location_id) {
          setError("Org has no GHL location configured");
          setLocationId(null);
        } else {
          setLocationId(data.ghl_location_id as string);
          setError(null);
        }
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [organizationId]);

  return { locationId, isLoading, error };
}
